var e="\n    visMode = outLife < 0.0? -1.0: visMode;\n";export{e as default};
